module.exports = __webpack_public_path__ + "img/hardware.b583f681.png";